import { CSVEntity } from '@cims-online/shared'
import CIMSTable from 'components/CIMSTable'
import { useColumns } from './hooks/useColumns'
import { HelpMessage } from 'utils/constants'
import { useEditOptions } from './hooks/useEditOptions'
import { useCreateOptions } from './hooks/useCreateOptions'
import RevertModal from './components/RevertModal'
import { useFDCTrackerContext } from '../../FDCTrackerContext'
import { useRestoreOptions } from './hooks/useRestoreOptions'
import { usePayItemsOptions } from './hooks/usePayItemsOptions'
import { useCustomRowOptions } from './hooks/useCustomRowOptions'
import { useAnyTrue } from 'hooks/useAnyTrue'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import DraftSubmitModal from './components/DraftSubmitModal'

const FDCTrackerTable: React.FC = () => {
  const {
    payItemGlobalId,
    fieldDesignChanges,
    mutations: { remove, restore },
  } = useFDCTrackerContext()

  const [loading] = useAnyTrue([
    fieldDesignChanges?.loading,
    remove.is,
    restore.is,
  ])
  return (
    <CIMSTable
      rowKey="id"
      loading={loading}
      records={fieldDesignChanges?.records ?? []}
      columns={useColumns()}
      actions={{
        header: {
          csv: !!payItemGlobalId ? undefined : CSVEntity.FieldDesignChanges,
          payItems: usePayItemsOptions(),
          onReload: fieldDesignChanges?.refetch,
          create: useCreateOptions(),
          deepLinkKey: 'id',
        },
        row: {
          help: `${HelpMessage.FieldDesignChanges.FDCTracker.Revert}, ${HelpMessage.UnlockSharePointFolder}, and ${HelpMessage.LockSharePointFolder}`,
          remove: useRemoveOptions(),
          restore: useRestoreOptions(),
          edit: useEditOptions(),
          custom: useCustomRowOptions(),
        },
      }}
      expand={useExpandOptions()}
    >
      <RevertModal />
      <DraftSubmitModal />
    </CIMSTable>
  )
}

export default FDCTrackerTable
